function genarateFont(data) {
  let bodyStyles = document.body.style;

  if (data.font_size_detail) {
    const fontList = data.font_size_detail.filter(
      el => el.font_size_id == data.font_size
    );

    if (data.font_size == "2") {
      bodyStyles.setProperty(
        "--font-caption",
        (fontList[0]?.value || "8") + "px"
      );
      bodyStyles.setProperty(
        "--font-helper",
        (fontList[1]?.value || "10") + "px"
      );
      bodyStyles.setProperty(
        "--font-body-sm",
        (fontList[2]?.value || "12") + "px"
      );
      bodyStyles.setProperty(
        "--font-body",
        (fontList[3]?.value || "14") + "px"
      );
      bodyStyles.setProperty(
        "--font-body-lg",
        (fontList[4]?.value || "16") + "px"
      );
      bodyStyles.setProperty(
        "--font-title-sm",
        (fontList[5]?.value || "18") + "px"
      );
      bodyStyles.setProperty(
        "--font-title",
        (fontList[6]?.value || "22") + "px"
      );
      bodyStyles.setProperty(
        "--font-heading",
        (fontList[7]?.value || "26") + "px"
      );
    } else if (data.font_size == "3") {
      bodyStyles.setProperty(
        "--font-caption",
        (fontList[0]?.value || "10") + "px"
      );
      bodyStyles.setProperty(
        "--font-helper",
        (fontList[1]?.value || "12") + "px"
      );
      bodyStyles.setProperty(
        "--font-body-sm",
        (fontList[2]?.value || "14") + "px"
      );
      bodyStyles.setProperty(
        "--font-body",
        (fontList[3]?.value || "16") + "px"
      );
      bodyStyles.setProperty(
        "--font-body-lg",
        (fontList[4]?.value || "18") + "px"
      );
      bodyStyles.setProperty(
        "--font-title-sm",
        (fontList[5]?.value || "20") + "px"
      );
      bodyStyles.setProperty(
        "--font-title",
        (fontList[6]?.value || "24") + "px"
      );
      bodyStyles.setProperty(
        "--font-heading",
        (fontList[7]?.value || "28") + "px"
      );
    } else if (data.font_size == "1") {
      bodyStyles.setProperty(
        "--font-caption",
        (fontList[0]?.value || "6") + "px"
      );
      bodyStyles.setProperty(
        "--font-helper",
        (fontList[1]?.value || "8") + "px"
      );
      bodyStyles.setProperty(
        "--font-body-sm",
        (fontList[2]?.value || "10") + "px"
      );
      bodyStyles.setProperty(
        "--font-body",
        (fontList[3]?.value || "13") + "px"
      );
      bodyStyles.setProperty(
        "--font-body-lg",
        (fontList[4]?.value || "14") + "px"
      );
      bodyStyles.setProperty(
        "--font-title-sm",
        (fontList[5]?.value || "16") + "px"
      );
      bodyStyles.setProperty(
        "--font-title",
        (fontList[6]?.value || "20") + "px"
      );
      bodyStyles.setProperty(
        "--font-heading",
        (fontList[7]?.value || "24") + "px"
      );
    }
  }
  const thaiFont = "/font/Kanit-light.ttf";
  const latinFont = "/font/Gotham-Light.otf";
  const thaiRange = "U+0E00-0E7F";
  const latinRange =
    "U+0000-024F, U+0300-036F, U+2000-206F, U+20A0-20CF, U+2100-218F, U+2190-21FF, U+2200-22FF";

  const formatOf = url => {
    const ext = url.split(".").pop().toLowerCase();
    if (ext === "otf") return "opentype";
    if (ext === "woff2") return "woff2";
    if (ext === "woff") return "woff";
    return "truetype";
  };

  const newStyle = document.createElement("style");
  const fontFaces = [400, 500, 600]
    .flatMap(weight => [
      `@font-face {
        font-family: 'CustomFont';
        src: url('${thaiFont}') format('${formatOf(thaiFont)}');
        font-weight: ${weight};
        font-display: swap;
        unicode-range: ${thaiRange};
      }`,
      `@font-face {
        font-family: 'CustomFont';
        src: url('${latinFont}') format('${formatOf(latinFont)}');
        font-weight: ${weight};
        font-display: swap;
        unicode-range: ${latinRange};
      }`
    ])
    .join("\n");

  newStyle.appendChild(document.createTextNode(fontFaces));
  document.head.appendChild(newStyle);
}

export { genarateFont };
